export default __webpack_public_path__ + "static/media/BauLF-Medium.83329d20.ttf";